export class ControlBase<T> {
    value;
    formControlName: string;
    label: string;
    placeholder: string;
    required: boolean;
    order: number;
    controlType: string;
    type: string;
    eleBtn:boolean;
    options: string[];
    pattern: string;
    hidden: boolean;
    data_type: string;
    readonly: boolean;
    minimum: number;
    maximum: number;
    keepAsterisk: boolean;
    displayOrder: number;
    minLength: number;
    maxLength: number;
    maxNumberLength:number;
    /* checked: boolean; */

    constructor(options: {
        value?: any;
        formControlName?: string;
        label?: string;
        placeholder?: string;
        required?: boolean;
        order?: number;
        controlType?: string;
        type?: string;
        pattern?: string;
        options?: string[];
        hidden?: boolean;
        readonly?: boolean;
        data_type?:string;
        eleBtn?:boolean;
        minimum?: number;
        maximum?: number;
        checked?: boolean;
        displayOrder?: number;
        minLength?: number;
        maxLength?: number;
        maxNumberLength?:number;
    } = {}) {
        this.value = options.value;
        this.formControlName = options.formControlName || '';
        this.label = options.label || '';
        this.placeholder = options.placeholder || '';
        this.required = !!options.required;
        this.order = options.order === undefined ? 1 : options.order;
        this.controlType = options.controlType || '';
        this.type = options.type || '';
        this.options = options.options || [];
        this.pattern = options.pattern!;
        this.hidden = options.hidden || false;
        this.eleBtn=false;
        this.readonly = options.readonly || false;
        this.minimum = options.minimum!;
        this.maximum = options.maximum!;
        this.keepAsterisk = true;
        this.data_type = options.data_type || '';
        this.displayOrder = options.displayOrder!;
        this.minLength = options.minLength!;
        this.maxLength = options.maxLength!;
        this.maxNumberLength = options.maximum?.toString().length!;
    }
}
